'use strict';

exports.__esModule = true;
exports.decodeJwtToken = exports.decrypt = exports.encrypt = undefined;

var _cryptoJs = require('crypto-js');

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

var _atob = require('atob');

var _atob2 = _interopRequireDefault(_atob);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var key = '8C6A5A98C796D1293C2129FE89E51';

/**
 * Encrypt a string
 * @param {string} data
 * @returns {string}
 */
var encrypt = exports.encrypt = function encrypt(data) {
  return _cryptoJs2.default.AES.encrypt(data, key);
};

/**
 * Decrypt a string
 * @param {string} data
 * @returns {string}
 */
var decrypt = exports.decrypt = function decrypt(data) {
  var bytes = _cryptoJs2.default.AES.decrypt(data.toString(), key);
  return bytes.toString(_cryptoJs2.default.enc.Utf8);
};

/**
 * Decode the JWT token
 * @param {string} token
 * @returns {Object}
 */
var decodeJwtToken = exports.decodeJwtToken = function decodeJwtToken(token) {
  var header = JSON.parse((0, _atob2.default)(token.split('.')[0]));
  var payLoad = JSON.parse((0, _atob2.default)(token.split('.')[1]));

  return {
    header: header,
    payLoad: payLoad
  };
};